export default __webpack_public_path__ + "static/media/my_pic.aa01de0a.jpg";